import { useState } from 'react';
import { Stack, Typography } from '@mui/material';
import { TabStrip } from '../components/TabStrip';
import { AppearancePanel } from '../features/settings/AppearancePanel';
import { VersionLine } from '../features/settings/VersionLine';
import { SettingsForm, type SettingsTab } from '../features/settings/SettingsForm';
import { SectionPage } from './SectionPage';

const TABS: SettingsTab[] = ['General', 'KPI Targets', 'Rule Book'];
const ABOUT: Record<SettingsTab, string> = {
  General: 'How the app looks, and the exchange rates every money figure is worked out with.',
  'KPI Targets': 'The acceptable number for each KPI. Dashboards show the actual number next to it.',
  'Rule Book':
    'How many days things wait before they change state or need chasing. The app uses these, and Claude will too.',
};

/** Preferences, a tab at a time: General (appearance, exchange rates), KPI Targets and the Rule Book */
export function PreferencesPage() {
  const [tab, setTab] = useState<SettingsTab>('General');
  return (
    <SectionPage title="Preferences">
      <TabStrip tabs={TABS} value={tab} onChange={setTab} />
      <Typography color="text.secondary">{ABOUT[tab]}</Typography>
      <Stack spacing={2}>
        {tab === 'General' && <AppearancePanel />}
        <SettingsForm tab={tab} />
        {tab === 'General' && <VersionLine />}
      </Stack>
    </SectionPage>
  );
}
